import type { QTableColumn } from 'quasar';
import { StartMethod } from './enum/StartMethod';
// Get
type GetMailTemplate = {
  id: string;
  name: string;
};
export type GetMailSetting =
  | GetMailSettingStartDecisionRequest
  | GetMailSettingAnswerRequest
  | GetMailSettingStartNotification;
type GetMailSettingIsSendFalse = {
  is_send: false;
};
export type GetMailSettings =
  | GetMailSettingsSemiAuto
  | GetMailSettingsManual
  | GetMailSettingsAuto;
export type GetMailSettingsSemiAuto = {
  start_decision_request: GetMailSettingStartDecisionRequest;
  answer_request: GetMailSettingAnswerRequest;
  start_notification: GetMailSettingStartNotification;
};
type GetMailSettingsManual = {
  answer_request: GetMailSettingAnswerRequest;
  start_notification: GetMailSettingStartNotification;
};
type GetMailSettingsAuto = {
  answer_request: GetMailSettingAnswerRequest;
  start_notification: GetMailSettingStartNotification;
};
// 開始判断依頼
export type GetMailSettingStartDecisionRequest =
  | GetMailSettingStartDecisionRequestIsSendTrue
  | GetMailSettingIsSendFalse;
type GetMailSettingStartDecisionRequestIsSendTrue = {
  is_send: true;
  mail_template: GetMailTemplate;
};
// 回答依頼
export type GetMailSettingAnswerRequest =
  | GetMailSettingAnswerRequestIsSendTrue
  | GetMailSettingIsSendFalse;
type GetMailSettingAnswerRequestIsSendTrue = {
  is_send: true;
  mail_template: GetMailTemplate;
  is_resend: boolean;
};
// 開始通知
export type GetMailSettingStartNotification =
  | GetMailSettingStartNotificationIsSendTrue
  | GetMailSettingIsSendFalse;
type GetMailSettingStartNotificationIsSendTrue = {
  is_send: true;
  mail_template: GetMailTemplate;
};
type GetResourceTypeCommon = {
  id: string;
  name: string;
  enquete_template: {
    id: string;
    name: string;
  };
  enquete_name: string;
};
type GetResourceTypeSemiAuto = {
  start_method: 'semiauto';
  mail_settings: GetMailSettingsSemiAuto;
} & GetResourceTypeCommon;
type GetResourceTypeManual = {
  start_method: 'manual';
  mail_settings: GetMailSettingsManual;
} & GetResourceTypeCommon;
type GetResourceTypeAuto = {
  start_method: 'auto';
  mail_settings: GetMailSettingsAuto;
} & GetResourceTypeCommon;
export type GetResourceType =
  | GetResourceTypeSemiAuto
  | GetResourceTypeManual
  | GetResourceTypeAuto;

// Send
export type SendMailSetting =
  | SendMailSettingStartDecisionRequest
  | SendMailSettingAnswerRequest
  | SendMailSettingStartNotification;
type SendMailSettingIsSendFalse = {
  is_send: false;
};
export type SendMailSettings =
  | SendGetMailSettingsSemiAuto
  | SendGetMailSettingsManual
  | SendGetMailSettingsAuto;
type SendGetMailSettingsSemiAuto = {
  start_decision_request: SendMailSettingStartDecisionRequest;
  answer_request: SendMailSettingAnswerRequest;
  start_notification: SendMailSettingStartNotification;
};
type SendGetMailSettingsManual = {
  answer_request: SendMailSettingAnswerRequest;
  start_notification: SendMailSettingStartNotification;
};
type SendGetMailSettingsAuto = {
  answer_request: SendMailSettingAnswerRequest;
  start_notification: SendMailSettingStartNotification;
};
// 開始判断依頼
export type SendMailSettingStartDecisionRequest =
  | SendMailSettingStartDecisionRequestIsSendTrue
  | SendMailSettingIsSendFalse;
type SendMailSettingStartDecisionRequestIsSendTrue = {
  is_send: true;
  mail_template_id: string;
};
// 回答依頼
export type SendMailSettingAnswerRequest =
  | SendMailSettingAnswerRequestIsSendTrue
  | SendMailSettingIsSendFalse;
type SendMailSettingAnswerRequestIsSendTrue = {
  is_send: true;
  mail_template_id: string;
  is_resend: boolean;
};
// 開始通知
export type SendMailSettingStartNotification =
  | SendMailSettingStartNotificationIsSendTrue
  | SendMailSettingIsSendFalse;
type SendMailSettingStartNotificationIsSendTrue = {
  is_send: true;
  mail_template_id: string;
};
type SendResourceTypeCommon = {
  id: string;
  enquete_template_id: string;
  enquete_name: string;
};
type SendResourceTypeSemiAuto = {
  start_method: 'semiauto';
  mail_settings: SendGetMailSettingsSemiAuto;
} & SendResourceTypeCommon;
type SendResourceTypeManual = {
  start_method: 'manual';
  mail_settings: SendGetMailSettingsManual;
} & SendResourceTypeCommon;
type SendResourceTypeAuto = {
  start_method: 'auto';
  mail_settings: SendGetMailSettingsAuto;
} & SendResourceTypeCommon;
export type SendResourceType =
  | SendResourceTypeSemiAuto
  | SendResourceTypeManual
  | SendResourceTypeAuto;

export type StartSettingGetAttributes = {
  id: string;
  name: string;
  resource_types: GetResourceType[];
};
export type StartSettingSendAttributes = {
  resource_types: SendResourceType[];
};
export class ResourceTypeSettingModel {
  id: string;
  name: string;
  enquete_template: { id: string; name: string };
  enquete_name: string;
  start_method: StartMethod;
  mail_settings: {
    start_decision_request: {
      is_send: boolean;
      mail_template: GetMailTemplate;
    };
    answer_request: {
      is_send: boolean;
      mail_template: GetMailTemplate;
      is_resend: boolean;
    };
    start_notification: {
      is_send: boolean;
      mail_template: GetMailTemplate;
    };
  };

  constructor(input?: GetResourceType) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.enquete_template = input
      ? input.enquete_template
      : { id: '', name: '' };
    this.enquete_name = input ? input.enquete_name : '';
    this.start_method = input ? input.start_method : 'manual';
    this.mail_settings = {
      start_decision_request: {
        is_send:
          input && input.start_method == 'semiauto'
            ? input.mail_settings.start_decision_request.is_send
            : true,
        mail_template:
          input &&
          input.start_method == 'semiauto' &&
          input.mail_settings.start_decision_request.is_send == true
            ? input.mail_settings.start_decision_request.mail_template
            : { id: '', name: '' },
      },
      answer_request: {
        is_send: input ? input.mail_settings.answer_request.is_send : true,
        mail_template:
          input && input.mail_settings.answer_request.is_send == true
            ? input.mail_settings.answer_request.mail_template
            : { id: '', name: '' },
        is_resend:
          input && input.mail_settings.answer_request.is_send == true
            ? input.mail_settings.answer_request.is_resend
            : false,
      },
      start_notification: {
        is_send: input ? input.mail_settings.start_notification.is_send : true,
        mail_template:
          input && input.mail_settings.start_notification.is_send == true
            ? input.mail_settings.start_notification.mail_template
            : { id: '', name: '' },
      },
    };
  }
}
export class StartSettingModel {
  id: string;
  name: string;
  resource_types: ResourceTypeSettingModel[];

  constructor(input?: StartSettingGetAttributes) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.resource_types = input
      ? input.resource_types.map(
          (resource_type) => new ResourceTypeSettingModel(resource_type)
        )
      : [];
  }

  getId(): string {
    return this.id;
  }
  getUpdateAttributes(): StartSettingSendAttributes {
    return {
      resource_types: this.resource_types.map(
        (resource_type: GetResourceType): SendResourceType => {
          return {
            id: resource_type.id,
            enquete_template_id: resource_type.enquete_template.id,
            enquete_name: resource_type.enquete_name,
            start_method: resource_type.start_method,
            mail_settings: this.getMailSettings(
              resource_type.start_method,
              resource_type.mail_settings
            ),
          } as SendResourceType;
        }
      ),
    };
  }
  getMailSettings(
    start_method: StartMethod,
    mail_settings: GetMailSettings
  ): SendMailSettings {
    if (start_method == 'semiauto') {
      return {
        start_decision_request:
          this.getMailSettingStartDecisionRequest(mail_settings),
        answer_request: this.getMailSettingAnswerRequest(mail_settings),
        start_notification: this.getMailSettingStartNotification(mail_settings),
      };
    } else {
      return {
        answer_request: this.getMailSettingAnswerRequest(mail_settings),
        start_notification: this.getMailSettingStartNotification(mail_settings),
      };
    }
  }
  getMailSettingStartDecisionRequest(
    mail_settings: GetMailSettings
  ): SendMailSettingStartDecisionRequest {
    const mailSetting = mail_settings as GetMailSettingsSemiAuto;
    if (mailSetting.start_decision_request.is_send) {
      return {
        is_send: mailSetting.start_decision_request.is_send,
        mail_template_id: mailSetting.start_decision_request.mail_template.id,
      };
    } else {
      return {
        is_send: mailSetting.start_decision_request.is_send,
      };
    }
  }
  getMailSettingAnswerRequest(
    mail_settings: GetMailSettings
  ): SendMailSettingAnswerRequest {
    if (mail_settings.answer_request.is_send) {
      return {
        is_send: mail_settings.answer_request.is_send,
        mail_template_id: mail_settings.answer_request.mail_template.id,
        is_resend: mail_settings.answer_request.is_resend,
      };
    } else {
      return {
        is_send: mail_settings.answer_request.is_send,
      };
    }
  }
  getMailSettingStartNotification(
    mail_settings: GetMailSettings
  ): SendMailSettingStartNotification {
    if (mail_settings.start_notification.is_send) {
      return {
        is_send: mail_settings.start_notification.is_send,
        mail_template_id: mail_settings.start_notification.mail_template.id,
      };
    } else {
      return {
        is_send: mail_settings.start_notification.is_send,
      };
    }
  }
}
export type StartSettingCollection = StartSettingModel[];

export const StartSettingTableColumns: QTableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    align: 'left',
    field: 'id',
    sortable: true,
  },
  {
    name: 'name',
    label: '開始名',
    align: 'left',
    field: 'name',
    sortable: true,
  },
  {
    name: 'resource_types',
    label: 'リソースタイプ別の開始方法',
    align: 'left',
    field: 'resource_types',
    sortable: true,
    format: (value: GetResourceType[]) => {
      return value
        .map((resource_type: GetResourceType) => {
          return `「${resource_type.name}: ${resource_type.start_method}」`;
        })
        .join('、');
    },
  },
];
